var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconsFeedback({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icons-feedback",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons_feedback"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bounds",
    width: 16,
    height: 16,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10907",
    "data-name": "Path 10907",
    d: "M18.684,6.7v8.012a1.694,1.694,0,0,1-1.693,1.693h-5.36l-3,2.995-.01.01L8.6,19.4,7.118,19l.545-.54s3.409-3.4,3.409-3.4h5.92a.343.343,0,0,0,.339-.339V6.7a.343.343,0,0,0-.339-.339H5.486a.346.346,0,0,0-.342.342v8.008a.343.343,0,0,0,.339.339H6.66a1.362,1.362,0,0,1,1.359,1.352l0,.317v.014H8.011L6.69,18.1l-.018-1.339s-.006-.338-.006-.338l-1.182-.012A1.694,1.694,0,0,1,3.79,14.716V6.708a1.7,1.7,0,0,1,1.7-1.7H16.992A1.694,1.694,0,0,1,18.684,6.7Z",
    transform: "translate(-3.269 -3.482)",
    fill: "#c6cacc"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsFeedback);
export default __webpack_public_path__ + "static/media/icons-feedback.4cf33790.svg";
export { ForwardRef as ReactComponent };